{
  "role": {
    "notAllowed": "Nie posiadasz odpowiednich uprawnień"
  }
}
